import { __decorate, __extends } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PopupComponent from '@/components/messageBox/popup';

var MarketPopup =
/** @class */
function (_super) {
  __extends(MarketPopup, _super);

  function MarketPopup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 关闭
   */


  MarketPopup.prototype.onClickClose = function () {
    this.value = false;
  };

  MarketPopup.prototype.onClickImage = function () {
    location.href = 'https://m.qlchat.com/wechat/page/topic-intro?topicId=2000004790800969';
  };

  MarketPopup = __decorate([Component({
    template: "<MyPopup v-model=\"value\" class=\"market-popup\" :content-class=\"['center-popup']\" position=\"center\">\n        <img class=\"image\" v-thumbnail=\"'/meta/market/20190718/college_popup.jpg'\" />\n        <div class=\"btn-wrap\">\n            <MobileButton name=\"primary\"\n                class=\"btn-large btn-round\"\n                @click=\"onClickImage\">\n                \u62A5\u540D\u542C\u8BFE\n            </MobileButton>\n        </div>\n        <i class=\"icon\" @click=\"onClickClose\">&#xe60b;</i>\n    </MyPopup>"
  })], MarketPopup);
  return MarketPopup;
}(Mixins(PopupComponent));

export { MarketPopup };